import React from 'react';
import { RectangleGroupIcon } from '@heroicons/react/24/outline';
import ButtonTabs from '@ui/tabs/ButtonTabs';
import CaptionGroup, { CaptionGroupDivider } from '@ui/captiongroup/CaptionGroup';
import FormButton from '@ui/button/FormButton';
import type { BiView } from '../BiView.utilities';

// The View by frame of the BI reports with company groups (Segmentation, its Property comparison, Channels): the rows of the
// report are the company groups or the single items. ROO2-277 D23: the button that edits the groups sits in the frame, after
// a divider: a text button of the height of the tabs (32 px), so the frame keeps the height of the other frames. A user who
// is not a company admin gets no button (onEdit null).
type Props = {
	value: BiView,
	onChange: (view: BiView) => void,
	// With no group, the tab Groups is off and says "No group yet".
	hasGroups: boolean,
	// The tab of the single items, for example "PMS segments" or "Channels".
	singleLabel: string,
	// The accessible name of the tabs, for example "Rows of the report".
	label: string,
	onEdit: (() => void) | null,
	editLabel: string,
};

const BiViewBy: React.FunctionComponent<Props> = ({ value, onChange, hasGroups, singleLabel, label, onEdit, editLabel }) =>
	<CaptionGroup caption="View by" className="col-span-2 w-full sm:col-span-1 sm:w-auto">
		<div className={onEdit !== null ? 'flex w-full min-w-0 flex-wrap items-center gap-x-3 gap-y-2' : 'w-full min-w-0'}>
			<div className="min-w-0 flex-1 sm:flex-none">
				<ButtonTabs label={label} value={value} onChange={next => onChange(next as BiView)}
					options={[{ value: 'GROUPS', label: 'Groups', disabled: !hasGroups, note: hasGroups ? undefined : 'No group yet' },
						{ value: 'SINGLE', label: singleLabel }]} />
			</div>
			{onEdit !== null && <><CaptionGroupDivider className="hidden sm:block" />
				<FormButton state="text" size="small" extraClassName="h-8 py-0" icon={<RectangleGroupIcon aria-hidden="true" className="h-4 w-4 text-gray-500" />}
					onClick={onEdit}>{editLabel}</FormButton></>}
		</div>
	</CaptionGroup>;

export default BiViewBy;
